import { render, staticRenderFns } from "./CustomDropActionItem.vue?vue&type=template&id=987937ee&scoped=true"
import script from "./CustomDropActionItem.vue?vue&type=script&lang=js"
export * from "./CustomDropActionItem.vue?vue&type=script&lang=js"
import style0 from "./CustomDropActionItem.vue?vue&type=style&index=0&id=987937ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987937ee",
  null
  
)

export default component.exports